import React, { useRef, useState, useEffect } from 'react'
import {
  Dialog,
  Typography,
  IconButton,
  Button,
  CircularProgress
} from '@material-ui/core'
import { Close, Save, Image } from '@material-ui/icons'
import { useDispatch } from 'react-redux'
import { updateLayout } from '~/state/modules/planimetry'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { validateExtension } from 'views/utils/functions'
import { useStyles } from './ImageDialog.style'

export const ImageDialog = ({
  open,
  onClose,
  layout,
  locationId,
  onUpdateLayout
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const fileInput = useRef(null)
  const [newImageFile, setNewImageFile] = useState(null)
  const [previewUrl, setPreviewUrl] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const layoutName = layout?.Name
  const imageLayout = layout?.ImageCdnUrl

  useEffect(() => {
    if (!open) {
      setNewImageFile(null)
      setPreviewUrl(null)
    }
  }, [open])

  const handleSelectImage = () => {
    fileInput.current.click()
  }

  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0]
      if (validateExtension(file.name)) {
        setNewImageFile(file)
        setPreviewUrl(URL.createObjectURL(file))
      }
    }

    event.target.value = ''
  }

  const handleSave = async () => {
    if (!newImageFile) return

    try {
      setIsSubmitting(true)
      await dispatch(
        updateLayout({
          LayoutId: layout?.Id,
          LayoutName: layout?.Name,
          ImageFile: newImageFile,
          LocationId: locationId
        })
      )
      showSnackbarSuccess('¡Imagen de planimetría actualizada!')
      setNewImageFile(null)
      setPreviewUrl(null)
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setIsSubmitting(false)
      if (onUpdateLayout) {
        onUpdateLayout()
      }
      onClose()
    }
  }

  const displayedImage = previewUrl || imageLayout

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          position: 'relative',
          background: '#fff'
        }
      }}>
      <input
        type='file'
        id='imageFileDialog'
        style={{ display: 'none' }}
        accept='.png,.jpg,.jpeg,.pjp,.pjpeg,.jfif'
        onChange={handleFileChange}
        ref={fileInput}
      />
      <div className={classes.titleContainer}>
        <div className={classes.titleRow}>
          <Typography className={classes.layoutName} variant='h4'>
            {layoutName}
          </Typography>
          <Button
            onClick={handleSelectImage}
            color='primary'
            variant='outlined'
            size='small'
            startIcon={<Image />}
            className={classes.changeImageButton}>
            Cambiar Imagen
          </Button>
        </div>
        <IconButton
          aria-label='close'
          onClick={onClose}
          className={classes.button}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.containerImage}>
        <img
          src={displayedImage}
          alt='plany'
          width={700}
          height={500}
          className={classes.image}
        />
      </div>
      <div className={classes.actionsContainer}>
        <Button
          onClick={handleSave}
          disabled={!newImageFile || isSubmitting}
          color='primary'
          variant='contained'
          startIcon={
            isSubmitting ? (
              <CircularProgress size={20} color='secondary' />
            ) : (
              <Save />
            )
          }>
          {isSubmitting ? 'Guardando...' : 'Guardar'}
        </Button>
      </div>
    </Dialog>
  )
}

export default ImageDialog
